<template lang="pug">
    section.table-data-search
        div.header-select(ref="refrence" @click.stop="showSelect")
            span {{search || title}}
                span
                i(class="el-icon el-icon-caret-bottom")
        transition(name="height-fade")
            div.table-data-search-container(ref="popper" v-show="isShow" @click.stop)
                div.left
                    input(type="text" @input="inputSpaceLimit($data, 'search')" @keydown.enter="confirm" v-model="search" ref="input" :placeholder="placeholder || '搜索'")
                div.right
                    i(v-if="search" @click="clear" class="iconfont icondelete")
                    button.btn(@click="confirm") 搜索

</template>

<script>
import Popper from 'popper.js'
import event from '@/utils/event'
import { inputSpaceLimit } from '@/utils'

export default {
    data() {
        return {
            isShow: false,
            search: ''
        }
    },

    props: {
        title: String, // 表头默认文字
        placeholder: String
    },

    created() {
        window.document.addEventListener('click', this.close)
        window.addEventListener('keydown', this.listenKeydown)
        this.symbol = Symbol('tableDataFilterSymbol') // 用于关闭非自身表头筛选
        event.$on('TABLE_DATA_FILTER_CLICK', this.listenOtherTableFilterClick)
    },

    mounted() {
        document.body.appendChild(this.$refs.popper)
        this.popper = new Popper({
            getBoundingClientRect: () => this.$refs.refrence.getBoundingClientRect(),
            clientWidth: this.$refs.refrence.clientWidth,
            clientHeight: this.$refs.refrence.clientHeight
        }, this.$refs.popper, {
            placement: "bottom-start",
            modifiers: {
                offset: {
                    offset: '0, 10px, 0, 0'
                }
            }
        })
    },

    beforeDestroy() {
        document.removeEventListener('click', this.close)
        window.removeEventListener('keydown', this.listenKeydown)
        event.$off('TABLE_DATA_FILTER_CLICK', this.listenOtherTableFilterClick)
        if (document.body.contains(this.$refs.popper)) {
            document.body.removeChild(this.$refs.popper)
        }
        clearInterval(this.timer)
    },

    methods: {
        inputSpaceLimit,

        listenOtherTableFilterClick(symbol) {
            if (symbol !== this.symbol) {
                this.close()
            }
        },

        showSelect() {
            if (this.isShow) {
                this.close()
                return
            }

            this.isShow = true
            this.$nextTick(() => {
                this.$refs.input.focus()
            })
            event.$emit('TABLE_DATA_FILTER_CLICK', this.symbol)
            this.popper.update()
            const headerRect = this.$refs.refrence.getBoundingClientRect()
            this.timer = setInterval(() => {
                const nowPositon = this.$refs.refrence.getBoundingClientRect()
                if (headerRect.top !== nowPositon.top || headerRect.left !== nowPositon.left) {
                    this.close()
                }
            }, 100)
        },

        listenKeydown(e) {
            if (e.keyCode === 13 && this.isShow) {
                this.confirm()
            }
        },

        close() {
            this.isShow = false
            clearInterval(this.timer)
        },

        clear() {
            this.search = ''
        },

        confirm() {
            this.close()
            this.$emit('search', this.search)
        },

        reset() {
            this.search = ''
        }
    }
}
</script>

<style lang="scss">
.table-data-search {
    position: relative;
    display: inline-grid;
    padding: 0;
    margin: 0;
    width: 100%;

    div {
        padding: 0;
    }

    .header-select {
        position: relative;
        height: 28px;
        line-height: 28px;
        width: 100%;
        background: #fff;
        font-size: 14px;
        padding: 0 10px;
        color: #333;
        white-space: nowrap;

        i {
            float: right;
            line-height: 28px;
        }
    }
}

.height-fade-enter-active {
    transition: height 0.3s ease, opacity 0.3s ease;
}

.height-fade-leave-active {
    transition: height 0.3s ease, opacity 0.3s ease;
}

.height-fade-enter,
.height-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
    height: 0 !important;
    opacity: 0;
}

.table-data-search-container {
    position: fixed;
    top: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 300px;
    height: 44px;
    padding: 0 !important;
    background: #fff;
    z-index: 99;
    box-shadow: 0 0 4px 0 rgba(153, 153, 153, 0.5);
    border-radius: 4px;

    div.left {
        flex: 1;

        input {
            width: 100%;
            padding: 0 8px;
            font-size: 14px;
            color: #333;
            border: none !important;
        }
    }

    .iconfont {
        position: relative;
        top: 2px;
        margin-right: 8px;
        color: #999;
        font-size: 18px;
    }

    .btn {
        padding: 3px 8px;
        font-size: 14px;
        color: #009688;
        font-weight: bold;
        background: transparent;
        border-left: 1px solid #DDD;
    }
}
</style>
